import { render, staticRenderFns } from "./homeDashboardAnamneseStatistics.vue?vue&type=template&id=7e56a237&scoped=true"
import script from "./homeDashboardAnamneseStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardAnamneseStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardAnamneseStatistics.vue?vue&type=style&index=0&id=7e56a237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56a237",
  null
  
)

export default component.exports